<template>

  <BryntumDateTimeField v-if="!mode || mode == 'datetime'" :value="'2024-02-16T23:11:20.183Z'" format="YYMMDD"
    :weekStartDay="1" :onChange="e => setDate(e.value)">
  </BryntumDateTimeField>
  <BryntumDateField v-else-if="mode == 'date'" :value="value" :label="label" :weekStartDay="1" :onChange="setDate">
  </BryntumDateField>
  <BryntumTimeField v-else-if="mode == 'time'" :value="value" :label="label" :weekStartDay="1" :onChange="setDate">
  </BryntumTimeField>

  <BryntumDateField v-else :width="150" :height="30" :format="'DD/MM/YYYY'" :value="value" :strict-parsing="true"
    @action="$emit('input', $event.value)">
  </BryntumDateField>
  <!-- 
  <div :id="uniqueid" />
  -->
</template>


<script>
import InputMixin from "@/helpers/Mixins/InputMixin";
//import ExternalChangeWarning from "@/components/Inputs/Parts/ExternalChangeWarning.vue";

import {
  BryntumDateTimeField,
  BryntumTimeField,
  BryntumDateField,
} from '@bryntum/schedulerpro-vue';

import {
  DateTimeField,
  DateField,
  TimeField,
} from "@bryntum/schedulerpro";

export default {
  name: "QDateTimeField",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    value: [Date, String],
    singleline: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    emitOnlyOnBlur: Boolean,
    rules: Array,

    mode: {
      type: String,  //datetime, time (just time), date, week, month
      default: 'datetime',
    },
    stepSize: String,

    minuteIncrement: {
      default: 15,
      type: Number,
    }
  },
  components: {
    //ExternalChangeWarning,
    BryntumDateTimeField,
    BryntumTimeField,
    BryntumDateField,
  },
  mixins: [InputMixin],

  data() {
    return {
      edit: false,
      newValue: this.value,
      field: null,
      mounted: false,
      uniqueid: /*(Math.random() * 100) + */'datetimefield',
    };
  },

  mounted() {
    this.setInternalDate();
    if (!this.field) {
      //this.initField();
    }
    this.mounted = true;
  },

  methods: {
    initField() {
      const baseFieldConfig = this.getBaseFieldConfig();
      const dateFieldConfig = this.getDateFieldConfig();
      const timeFieldConfig = this.getTimeFieldConfig();

      var f = baseFieldConfig;
      if (this.mode) {
        var lmode = this.mode.toLowerCase();
        if (['date', 'week', 'month'].includes(lmode)) {
          f = new DateField({
            ...f,
            ...dateFieldConfig,
          });
        }
        else if (lmode == 'time') {
          f = new TimeField({
            ...f,
            ...timeFieldConfig,
          });
        }
        else { //datetime or default
          f = new DateTimeField({
            ...f,
            dateField: dateFieldConfig,
            timeField: timeFieldConfig,
          });
        }
      }
      this.field = f;
    },

    getBaseFieldConfig() {
      const changeVal = (e) => this.outputDate(e.value);
      //const log = (e) => console.log(e);

      const initalVal = this.newValue;
      const label = this.label;
      const disabled = this.disabled;
      const uniqueidkey = this.uniqueid;
      var config = {
        appendTo: uniqueidkey,
        cls: "QDateTimeField",
        labelPosition: 'above',
        labelCls: 'v-label',
        value: initalVal,
        label: label,
        readOnly: disabled,

        onChange: changeVal,
        //onFocusIn: log,
        //onFocusOut: log,
        //onInput: log,
      };
      return config;
    },

    getDateFieldConfig() {
      var config = { //DateFieldConfig
        weekStartDay: 1, //start week on monday
        format: this.parsedFormat,
        step: this.parsedStepSize,
      };
      return config;
    },

    getTimeFieldConfig() {
      const minuteIncrement = this.minuteIncrement;
      var config = { //TimeFieldConfig
        format: 'HH:mm',
        step: minuteIncrement + ' min',
        picker: {
          items: {
            minute: {
              step: minuteIncrement,
            }
          }
        },
      };
      return config;
    },

    setInternalDate() {
      this.newValue = new Date(this.value);
      if (this.field) {
        this.field.value = this.newValue;
      }
    },

    outputDate(val) {
      if (this.mounted) {
        val.setMinutes(Math.round(val.getMinutes() / this.minuteIncrement) * this.minuteIncrement);

        this.$emit('input', val);
      }
    },
  },

  computed: {
    parsedFormat() {
      if (this.format) {
        return this.format;
      }
      var keyMapObj = {
        'month': 'MMMM Y',
        'week': 'Wp Y',
      };
      var f = keyMapObj[this.mode] ?? this.$t("servicesystem.formatting.dateformat");
      return f;
    },
    parsedStepSize() {
      if (this.stepSize) {
        return this.stepSize;
      }
      else {
        var keyMapObj = {
          'month': "1 month",
          'week': "1 week"
        };
        var step = keyMapObj[this.mode] ?? "1d";
        return step;
      }
    },
  },

  watch: {
    value: function () {
      this.setInternalDate()
    },

    mode: function () {
      this.initField();
    },
  },
};
</script>


<style lang='scss'>
.QDateTimeField .b-field-inner {
  border-style: none;
  border-bottom: 1px solid;
  border-bottom-color: grey;
  //-webkit-border-end: none !important;
  //border-inline-end: none !important;
}

.QDateTimeField.removeunderline .b-field-inner {
  border-bottom-style: none;
}


.b-invalid .b-field-inner {
  border-bottom: 1px solid !important;
}

.QDateTimeField label {
  transform: scale(0.5);
  margin-bottom: -5px !important;
}
</style>
